import { ErrorScreen } from '@paysense-india-services/elevate-web'

import { EXTERNAL_ROUTES } from '@/constants/routes'

import { getImageUrl } from '@/assets/images'

const ErrorIcon = () => (
  <img alt="Page not found" height={190} src={getImageUrl('error')} width={234} />
)

const NotFoundPage = () => (
  <div className="appLayout ew-bg-primary ew-h-100 ew-d-flex ew-flex-column ew-justify-content-center">
    <ErrorScreen
      description="Page Not Found!!"
      ErrorImage={<ErrorIcon />}
      onButtonClick={() => (globalThis.location.href = EXTERNAL_ROUTES.WEBSITE)}
    />
  </div>
)

export default NotFoundPage
